/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// styles
import injectSheet from 'react-jss';
import theme from 'material/dropdowns/dropfilter/dropdownindicator/dropdownindicator_styles';
// components
import Group from 'material/group/group';
import Icon from 'material/graphic/icon/icon';




/* ========== ~~~~~~~~~~ MENU > INDICATOR : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class DropDownFilterIndicator extends Component {
    componentDidMount() {
        return this.props.action === 'click' ? document.addEventListener('mousedown', this.handleOutsideClick, false) : null;
    }
    componentWillUnmount() {
        return this.props.action === 'click' ? document.removeEventListener('mousedown', this.handleOutsideClick, false) : null;
    }
	handleClick = (e) => {
		this.props.toggleMenu();
	};
    handleOutsideClick = (e) => {
        // ignore clicks on the component itself
        if (this.node.contains(e.target)) { return; }
        this.hideTip();
    };
	render() {
		let {icon, name, title, active, selected} = this.props;

		return (
	        <div className={`dropdownindicator active-${active} ${this.props.classes.dropdownindicator}`} onClick={this.handleClick} ref={node => {this.node=node;}}>
				<Group name={'iconTitle'}>
					<Icon name={icon} />
				<Group name={'nameTitle'} >
				<div className={'name'}>{name}</div>
					{(!active && selected) ? <div className={`selected`} >{`${selected} ${name}`}</div> : <div className={'title'}>{title}</div>}
				</Group>
				</Group>
                <Icon name={'sort-down'} />
	        </div>
		);
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(theme)(DropDownFilterIndicator);